import { constants } from "../../../constants";

export default class SoundOn {
    constructor(gb) {
        Object.assign(this, { gb });
    }

    IGT_handler(msg) {
        if (msg.Params === "true" || msg.Params === true) {
            this.gb.emitters.emit.web.soundOn();
        } else if (msg.Params === "false" || msg.Params === false) {
            this.gb.emitters.emit.web.soundOff();
        }
    }

    SPRIBE_handler(payload) {
        if (payload && payload.data && payload.data.value === true) {
            this.gb.emitters.emit.web.soundOn();
        } else {
            this.gb.emitters.emit.web.soundOff();
        }
    }

    YGG_handler(payload) {
        if (payload && payload.data && payload.data === 0) {
            this.gb.emitters.emit.web.soundOff();
        } else if (payload && payload.data && payload.data > 0) {
            this.gb.emitters.emit.web.soundOn();
        }
    }

    PT_handler(payload) {
        if (payload && !payload.mute) {
            this.gb.emitters.emit.web.soundOn();
        } else {
            this.gb.emitters.emit.web.soundOff();
        }
    }

    HBN_handler(payload) {
        if (payload && payload.value === true) {
            this.gb.emitters.emit.web.soundOn();
        } else if(payload && payload.value === false) {
            this.gb.emitters.emit.web.soundOff();
        }
    }

    SPIN_handler(payload) {
        if (payload && payload.isOn && payload.isOn === true) {
            this.gb.emitters.emit.web.soundOn();
        } else {
            this.gb.emitters.emit.web.soundOff();
        }
        // if (payload && payload.action && payload.action === true) {
        //     this.gb.emitters.emit.web.soundOn();
        // } else {
        //     this.gb.emitters.emit.web.soundOff();
        // }
    }

    // Sound on/off is handled in soundOff.js for both cases
    // ENDOR_handler(payload) {
    //     if (payload.mute !== undefined) {
    //         if (payload.mute) {
    //             this.gb.emitters.emit.web.soundOff();
    //         } else {
    //             this.gb.emitters.emit.web.soundOn();
    //         }
    //     }
    // }

    EDIG_handler(event){
        if (event.value === false) {
            this.gb.emitters.emit.web.soundOff();
            if (this.gb.api?.modules?.superWheel?.instanceAvailable) {
                this.gb.api.modules.superWheel.soundOff();
            }
        } else {
            this.gb.emitters.emit.web.soundOn();
            if (this.gb.api?.modules?.superWheel?.instanceAvailable) {
                this.gb.api.modules.superWheel.soundOn();
            }
        }
    }

    EYECON_handler(payload) {
        if (payload && typeof payload.enable === 'boolean') {
            if (payload.enable === true) {
                this.gb.emitters.emit.web.soundOn();
            } else {
                this.gb.emitters.emit.web.soundOff();
            }
        }
    }

    _default() {
        this.gb.emitters.emit.web.soundOn();
        if(this.gb.api && this.gb.api.modules && this.gb.api.modules.superWheel.instanceAvailable) {
            this.gb.api.modules.superWheel.soundOn();
        }
    }

    exposeEvent() {
        let event = {};
        switch (this.gb.gameProviderProtocol) {
            case constants.F1X2:
                event["audio-enable"] = this._default;
                break;
            case constants.IGT:
                event["rg2custAudioEnabled"] = this.IGT_handler;
                break;
            case constants.EDICT:
                event["audioEnabled"] = this._default;
                break;
            case constants.GSPOKER:
           // case constants.GSBINGO:
                event["soundOn"] = this._default;
                break;
            case constants.STAKELOGIC2:
                event["SOUND_ON"] = this._default;
                break;
            case constants.SPRIBE:
                event["ifc.sound"] = this.SPRIBE_handler;
                event["ifc.music"] = this.SPRIBE_handler;
                break;
            case constants.ISOFT:
                event["SOUNDS_UNMUTED"] = this._default;
                break;
            case constants.PT:
                event["ucip.sound.g2wSoundUpdateNotification"] = this.PT_handler;
                break;
            case constants.YGG:
                event["audio/volume"] = this.YGG_handler;
                break;
            case constants.HBN:
                event["audioToggle"] = this.HBN_handler;
                break;
            case constants.SPIN:
                event["volume"] = this.SPIN_handler;
                break;
            case constants.WD:
                event["WGEAPI.soundOn"] = this._default;
                break;
            case constants.WZD:
                event["soundOn.parent"] = this._default;
                break;
            case constants.EDIG:
                event["toggleSound"] = this.EDIG_handler;
                break;
            case constants.EYE:
                event["updateVolume"] = this.EYECON_handler;
                break;
            // case constants.ENDOR:
            //     event["settingsChanged"] = this.ENDOR_handler;
            //     break;
            default:
                event["soundOn"] = this._default;
        }

        return event;
    }
}
